<script type="application/javascript">
export default {
  props: {
    from: {
      type: Number,
      default: 0
    },
    to: {
      type: Number,
      default: 0
    },
    itemClass: {
      type: String,
      default: null
    }
  },
  render (createElement) {
    let items = (this.$slots.default || []).slice(this.from, this.to)
    // const count = items.length
    items = items.map((item, i) => {
      const classes = []
      if (this.itemClass) {
        if (this.itemClass === 'large-image-column' || this.itemClass === '2-column' || this.itemClass === 'option-3' || this.itemClass === 'option-2') {
          classes.push('col-sm-6 col-6')
        } else if (this.itemClass === '3-column') {
          classes.push('col-sm-4 col-6')
        } else if (this.itemClass === '6-column' || this.itemClass === 'list') {
          classes.push('col-sm-4 col-6')
        } else {
          classes.push(this.itemClass)
        }
      } else {
        classes.push('col-sm-4 col-6')
      }

      return createElement('div', { key: i, class: classes.join(' ') }, [item])
    })

    return createElement('div', { class: 'row options' }, items)
  }
}
</script>
